import {Injectable} from '@angular/core';

import {ApisService} from '../apis.service';
import {KeyItem} from '../key-item';

const OAUTH_GRANT_TYPES = {
  GRANT_TYPE_CLIENT_CREDENTIALS: {
    name: 'client_credentials',
    accessToken: '',
    accessTokenResponse: '',
    isError: false
  },
  GRANT_TYPE_PASSWORD: {
    name: 'password',
    accessToken: '',
    accessTokenResponse: '',
    isError: false,
    requiresUserAndPassword: true
  },
  GRANT_TYPE_REFRESH: {
    name: 'refresh_token',
    accessToken: '',
    accessTokenResponse: '',
    isError: false,
    requiresRefreshToken: true
  }
};

@Injectable({
  providedIn: 'root'
})
export class ApplicationKeysService {
  constructor(private apisService: ApisService) {
  }

  getGrantTypesAvailable() {
    return [
      OAUTH_GRANT_TYPES.GRANT_TYPE_CLIENT_CREDENTIALS,
      OAUTH_GRANT_TYPES.GRANT_TYPE_PASSWORD,
      OAUTH_GRANT_TYPES.GRANT_TYPE_REFRESH
    ];
  }

  getOauthTokenCurl(keyItem: KeyItem, grantType: any, user: string, password: string, refreshToken: string) {
    let curl: string;

    if (keyItem && grantType) {
      curl = `curl ${this.apisService.getOauthTokenUri()}`;
      if (this.apisService.getOauthTokenUriHasPort()) {
        curl += ' -k';
      }
      curl += ` -u ${keyItem.consumerKey}:${keyItem.consumerSecret}`;
      curl += ` -d "grant_type=${grantType.name}`;

      switch (grantType) {
        case OAUTH_GRANT_TYPES.GRANT_TYPE_CLIENT_CREDENTIALS:
          break;
        case OAUTH_GRANT_TYPES.GRANT_TYPE_PASSWORD:
          if (!user) {
            user = '$USERNAME';
          }
          if (!password) {
            password = '$PASSWORD';
          }
          curl += `&username=${user}&password=${password}`;
          break;
        case OAUTH_GRANT_TYPES.GRANT_TYPE_REFRESH:
          if (!refreshToken) {
            refreshToken = '$REFRESH_TOKEN';
          }
          curl += `&refresh_token=${refreshToken}`;
          break;
      }
      curl += '"';
    } else {
      curl = '';
    }
    return (curl);
  }

  getKeysAvailable(keys: KeyItem [], environmentsAvailable: string []) {
    // Filter by keys in the environmentsAvailable list:
    const keysFiltered: KeyItem [] = [];
    keys.forEach((key: KeyItem) => {
      if (environmentsAvailable.includes(key.keyType)) {
        keysFiltered.push(key);
      }
    });
    // Sort keys so alphabetical resulting in PRODUCTION always appears before SANDBOX, in both the table and the select control.
    const keysSorted = keysFiltered.sort((keyItem1: KeyItem, keyItem2: KeyItem) => {
      return keyItem1.keyType.localeCompare(keyItem2.keyType);
    });
    return keysSorted;
  }
}
